import React, { useContext } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";

import { formatBytes } from "../../../../../helpers/Utils";
import useMediaQuery from "../../../../../helpers/useMediaQuery";

import Highlighted from "../../../../../components/Highlighted/Highlighted";
import TableCell from "../../../../../components/tables/table-cell/TableCell";
import MarketCategories from "../../../../../data/types/MarketCategories";
import PathHelper from "../../../PathHelper";
import MarketPlaceContext from "../../MarketPlaceContext";
import DEFAULT_DATASET_LOGO from "../../../../../assets/images/general/user-photo.svg";

import LOCAL_STORAGE from "../../../../../_redux/localStorage";
import KeyIcon from "../../../../../components/Icon/icons/sidebar/KeyIcon";
import DownloadIcon from "../../../../../components/Icon/icons/general/DownloadIcon";
import BlockchainLogos from "../../../../../components/Icon/icons/blockchains/BlockchainLogos";
import ProductPrice from "../../details/price/ProductPrice";

import TooltipWidget from "../../../../../components/TooltipWidget/TooltipWidget";

import s from "./MarketProduct.module.scss";

export default function MarketProduct({ product }) {
	const { filters = {}, filterResults = () => {} } =
		useContext(MarketPlaceContext) || {};

	const { title, description, category, blockchain, id, price, size } = product;
	const { searchText, categories = [] } = filters;
	const stateData = LOCAL_STORAGE.loadState() || {};

	const isMobile = useMediaQuery("(max-width: 700px)");

	const productLogo = stateData.useMocks
		? product.product_logo
		: product.dataset_logo
		? "data:image/svg+xml;base64," + product.dataset_logo
		: DEFAULT_DATASET_LOGO;
	const path = PathHelper.getPath("market", `details/${id}`);

	return (
		<Link to={path} className={cx(s.root, isMobile ? s.mobile : "")}>
			<div className={s.categoryContainer}>
				<Highlighted
					className={s.category}
					highlight={searchText}
					text={MarketCategories[category]}
					onClick={(e) => {
						e.preventDefault();
						filterResults({
							categories: [...categories, category],
						});
					}}
				/>

				{blockchain && (
					<TooltipWidget tooltipText="Payments for this dataset require tokens on this blockchain.">
						<div className={s.blockchain}>
							<BlockchainLogos icon={blockchain} />
						</div>
					</TooltipWidget>
				)}
			</div>

			<div className={s.logoContainer}>
				<img src={productLogo} alt={"logo"} />
			</div>

			<TableCell
				type="name"
				text={title}
				textStyle={s.title}
				searchText={searchText}
				popoverText={title}
			/>

			<TableCell
				type="name"
				text={description}
				searchText={searchText}
				textStyle={s.description}
				popoverText={description}
			/>

			<div className={s.details}>
				{price && (
					<div className={s.price}>
						<KeyIcon color="#78909c" width={16} height={16} />
						<ProductPrice product={product} />
					</div>
				)}
				{size && (
					<div className={s.size}>
						<DownloadIcon color="#78909c" width={16} height={16} />
						<span>{formatBytes(size)}</span>
					</div>
				)}
			</div>
		</Link>
	);
}
